import mixpanel from 'mixpanel-browser';
import featureEnabled from 'shared/helper/feature';
import hasStatisticsConsent from 'rubriq/helpers/cookieConsent';
var initialized = false;
var MIXPANEL_TOKEN = null;
export var initMixpanel = function initMixpanel(token) {
  if (!featureEnabled('rubriq_mixpanel')) return;
  if (!hasStatisticsConsent()) return;
  if (initialized) return;
  if (!token) return;
  MIXPANEL_TOKEN = token;
  mixpanel.init(MIXPANEL_TOKEN, {
    autocapture: true,
    record_sessions_percent: 100,
    debug: process.env.NODE_ENV !== 'production',
    track_pageview: true,
    persistence: 'localStorage',
    record_heatmap_data: true
  });
  if (hasStatisticsConsent()) {
    mixpanel.opt_in_tracking();
  } else {
    mixpanel.opt_out_tracking();
  }
  mixpanel.register({
    app: 'Rubriq',
    environment: process.env.NODE_ENV
  });
  initialized = true;
};
export var trackEvent = function trackEvent(eventName) {
  var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!featureEnabled('rubriq_mixpanel')) return;
  if (!initialized) return;
  mixpanel.track(eventName, properties);
};
export var identifyUser = function identifyUser(userId) {
  var traits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!featureEnabled('rubriq_mixpanel')) return;
  if (!initialized) return;
  mixpanel.identify(userId);
  mixpanel.people.set(traits);
};
export var resetMixpanel = function resetMixpanel() {
  if (!featureEnabled('rubriq_mixpanel')) return;
  if (!initialized) return;
  mixpanel.reset();
  initialized = false;
};